import { isStringEmpty } from './string';
import compose from './compose';

const PUNCTUATION_RE = /(^[#]+\s+)|(^[*])/gm;
const MD_URL_RE = /(\[)?(\[([^\]]*)\]\((.*?)\))(\])?/gm;

export function markdownToPlainText(markdown = '', referenceSites = []) {
  if (isStringEmpty(markdown)) {
    return markdown;
  }

  let plainText = '';
  plainText = markdown
    // 去除加粗
    .replace(/\*{2,}/g, '')
    // 去除标题
    .replace(PUNCTUATION_RE, (searchValue, hashtag, asterisk) => {
      return hashtag ? '' : asterisk ? '-' : searchValue;
    });

  /**
   * 20240304 改版
   * 不再支持正文引用
   */
  // plainText = plainText.replace(MD_URL_RE, (_, tag) => '');

  // 去除前面多余的空行
  plainText = plainText.replace(/^[\n\r]+/g, '');
  return plainText;
}

const BRACKETS_RE = /(```[\S\s]*?```|`.*?`)|\\\[([\S\s]*?[^\\])\\]|\\\((.*?)\\\)/g;
function escapeBrackets(text) {
  return text.replaceAll(
    BRACKETS_RE,
    (match, codeBlock, squareBracket, roundBracket) => {
      if (codeBlock) {
        return codeBlock;
      } else if (squareBracket) {
        return `$$${squareBracket}$$`;
      } else if (roundBracket) {
        return `$${roundBracket}$`;
      }
      return match;
    }
  );
}

export function escapeLaTeX(text) {
  return escapeBrackets(text);
}
